import Resource from '@/api/resource'
import request from '@/utils/request'
class EventResource extends Resource {
  constructor() {
    super('api/v1/events')
  }

  getLessonInputOptions() {
    return request({
      url: '/' + this.uri + '/lesson/input/options',
      method: 'get'
    })
  }

  createCourse(resource) {
    return request({
      url: '/' + this.uri + '/course/one',
      method: 'post',
      data: resource
    })
  }

  updateCourse(resource, id) {
    return request({
      url: '/' + this.uri + '/course/one/' + id,
      method: 'put',
      data: resource
    })
  }

  removeCourse(id) {
    return request({
      url: '/' + this.uri + '/course/one/' + id,
      method: 'delete'
    })
  }

  getCourseList(query) {
    return request({
      url: '/' + this.uri + '/course/lists',
      method: 'get',
      params: query
    })
  }

  createLesson(resource) {
    return request({
      url: '/' + this.uri + '/lesson/one',
      method: 'post',
      data: resource
    })
  }

  updateLessonTimes(resource, id) {
    return request({
      url: '/' + this.uri + '/lesson/time/' + id,
      method: 'put',
      data: resource
    })
  }

  deleteLessonTimes(id) {
    return request({
      url: '/' + this.uri + '/lesson/time/' + id,
      method: 'delete'
    })
  }

  updateLesson(resource) {
    return request({
      url: '/' + this.uri + '/lesson/one/' + resource.id,
      method: 'put',
      data: resource
    })
  }

  removeLesson(id) {
    return request({
      url: '/' + this.uri + '/lesson/one/' + id,
      method: 'delete'
    })
  }

  getLessonList(query) {
    return request({
      url: '/' + this.uri + '/lesson/lists',
      method: 'get',
      params: query
    })
  }

  getLessonTimeList(query) {
    return request({
      url: '/' + this.uri + '/lesson/time/lists',
      method: 'get',
      params: query
    })
  }

  getCommentByLesson(query) {
    return request({
      url: '/' + this.uri + '/lesson/comment/' + query,
      method: 'get'
    })
  }

  createComment(resource) {
    return request({
      url: '/' + this.uri + '/lesson/comment',
      method: 'post',
      data: resource
    })
  }

  createCredit(resource) {
    return request({
      url: '/' + this.uri + '/credit/one',
      method: 'post',
      data: resource
    })
  }

  getSelfCreateRecords(query) {
    return request({
      url: '/' + this.uri + '/credit/self',
      method: 'get',
      params: query
    })
  }
}

export { EventResource as default }
